/**
 * Checks for tables within editorial blocks and adds a responsive wrapper class
 */
function addResponsiveWrapperToTables(): void {
  const tables = document.querySelectorAll(".editorialblock table");

  tables.forEach((table) => {
    const wrapper = document.createElement("div");
    wrapper.classList.add("table-responsive-wrapper");

    table.parentNode?.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });
}

addResponsiveWrapperToTables();
